<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="800px"
    content-class="ma-2 ma-sm-3"
  >
    <v-card>
      <ValidationObserver ref="observer" v-slot="{ invalid }">
        <v-form @submit.prevent.stop="onSubmit(invalid)">
          <v-card-title class="pa-2">
            <span class="heading">{{ title }}</span>
          </v-card-title>
          <v-card-text class="pa-0 ma-0 px-2">
            <v-row no-gutters>
              <v-col class="pa-0 ma-0 pb-1">
                <slot :observer="$refs.observer" />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey darken-1" text @click="onCancel">
              {{ $t("cancelar") }}
            </v-btn>
            <v-btn color="blue darken-1" text type="submit" :disabled="invalid">
              {{ $t("salvar") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
import { ValidationObserver, setInteractionMode } from "vee-validate";

setInteractionMode("eager");

export default {
  components: { ValidationObserver },
  props: {
    onSave: {
      type: Function,
      default: () => {},
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    showModal: {
      default: false,
      type: Boolean,
    },
    title: {
      default: "",
      type: String,
    },
    validateBeforeHide: {
      default: () => true,
      type: Function,
    },
  },
  computed: {
    auth() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    onSubmit(invalid) {
      this.onSave(invalid, this.$refs.observer);
      this.onCancel();
    },
    onCancel() {
      this.onClose(this.$refs.observer);
      this.hide();
    },
    hide() {
      if (this.validateBeforeHide()) {
        this.$store.commit("setShowModalDataForm", false);
      }
    },
  },
};
</script>

<style scoped></style>
